import { API_URL_PREFIX, BASE_API_URL, DEFAULT_TOKEN } from '../utilities/constants';
import { post } from '../utilities';

const getCampaingDetails = async (payload: { jobId: string; expertId: string; token: string }) => {
  return await post(`${API_URL_PREFIX}/campaign/getCampaigns`, payload);
};

const getCampaignAnalytics = async (payload: {
  token: string;
  expertId: string;
  jobId: string;
  campaignId: string;
}) => {
  return await post(`${API_URL_PREFIX}/campaign/getCampaignAnalytics`, payload);
};

const getCampaignLeadsAnalytics = async (payload: {
  token: string;
  expertId: string;
  jobId: string;
  campaignId: string;
  leadIds: number[];
}) => {
  return await post(`${API_URL_PREFIX}/campaign/getCampaignLeadsAnalytics`, payload);
};

const getCampaignAllLeads = async (payload: {
  token: string;
  expertId: string;
  jobId: string;
  campaignId: string;
  // leadIds : string[];
  skipCount: number;
  count?: number;
}) => {
  return await post(`${API_URL_PREFIX}/campaign/getLeads`, payload);
}

const addCampaignLeadFeedback = async (payload: {
  token: string;
  expertId: string;
  jobId: string;
  campaignId: number;
  userName: string;
  feedback: string;
}) => {
  return await post(`${API_URL_PREFIX}/campaign/addFeedback`, payload);
};


const updateBlackListCandidates = async (payload: {
  token: string;
  expertId: string;
  jobId: string;
  campaignId: string;
  userNames: string;
  whiteList: boolean;
}) => {
  return await post(`${API_URL_PREFIX}/campaign/updateBlackListCandidates`, payload);
};

const PrioritizeLeads = async (payload: {
  token: string;
  expertId: string;
  jobId: string;
  campaignId: string;
  userNames: string;
  actionType: string;
}) => {
  return await post(`${API_URL_PREFIX}/campaign/updateCandidatesPriority`, payload);
}


const getCandidateLeadDetails = async (payload: {
  token: string;
  expertId: string;
  jobId: string;
  userName: string;
  campaignId: string;
}) => {
  return await post(`${API_URL_PREFIX}/campaign/getLeadCandidateDetails`, payload);
}

const updateScoreThreshold = async (payload: {
  token: string;
  expertId: string;
  jobId: string;
  campaignId: string;
  threshold: number;

}) => {
  return await post(`${API_URL_PREFIX}/campaign/updateScoreThreshold`, payload);
}

const AddLead = async (payload: {
  token: string;
  expertId: string;
  jobId: string;
  campaignId: string;
  leadType: string;
  profiles: string[];
  documentUrl: string;
}) => { return await post(`${API_URL_PREFIX}/campaign/addLead`, payload) }

export const updateCampaignStatus = (
  expertId: string,
  campaignId: string,
  status?: string,
  autoSource?: string
) => {

  const payload: Record<string, any> = {
    token: DEFAULT_TOKEN,
    expertId,
    campaignId,
  };

  if (status !== undefined) payload.status = status;
  if (autoSource !== undefined) payload.autoSourcing = autoSource;

  return post(
    `${API_URL_PREFIX}/campaign/updateCampaign`,
    payload
  );
};

const getConversation = async (payload: {
  token: string;
  expertId: string;
  jobId: string;
  campaignId: string;
  username: string;
}) => {
  return await post(`${API_URL_PREFIX}/campaign/candidate/getConversation`, payload);
};

const postConversation = async (payload: {
  token: string;
  expertId: string;
  conversationId: string;
  jobId: string;
  campaignId: string;
  username: string;
  message: string;
}) => {
  return await post(`${API_URL_PREFIX}/campaign/candidate/postConversation`, payload);
};

const updateAutoResponse = async (payload: {
  token: string;
  expertId: string;
  conversationId: string;
  jobId: string;
  campaignId: string;
  username: string;
  autoResponse: boolean;
}) => {
  return await post(`${API_URL_PREFIX}/campaign/candidate/postConversation`, payload);
};

export const campaignManagementService = {
  getCampaingDetails,
  getCampaignAnalytics,
  getCampaignLeadsAnalytics,
  getCampaignAllLeads,
  addCampaignLeadFeedback,
  updateBlackListCandidates,
  PrioritizeLeads,
  getCandidateLeadDetails,
  updateScoreThreshold,
  AddLead,
  updateCampaignStatus,
  getConversation,
  postConversation,
  updateAutoResponse,
};